import {Component, OnInit} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import {defaultAvatarStyle, defaultRolesId} from '@features/security/security.constants';

@Component({
    standalone: false,
    selector: 'app-roles-and-users',
  templateUrl: './roles-and-users.component.html',
  styleUrl: './roles-and-users.component.scss'
})
export class RolesAndUsersComponent extends DialogDefinitionEditorBase implements OnInit {
  items = [];
  defaultStyle = defaultAvatarStyle;

  ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }

  private init() {
  }

  onRemoveUserOrRole(item: any) {
    if (!this.dialogField.value) {
      this.dialogField.value = [];
    }
    this.dialogField.value.push(item.id);
    this.dynamicFormControl.setValue(this.dialogField.value);
    // this.dialogField.options = this.dialogField.options.filter(option => option.id !== item.id);
  }

  IsRemoveButtonDisabled(item: any) {
    return item.text?.toLowerCase() === defaultRolesId.Administrator;
  }
}
